













































































































































































































































































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

// Mixins
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import MultilevelCategoriesFetcher from "@/components/app/admin/catalogue/products/multilevelCategories/multilevelCategoriesFetchMixin";
import SegmentTableMixin from "@/mixins/segmentTableMixin";
import BillingCyclesStore from "@/mixins/constants/billingCyclesStore";
import AdminBrands from "@/mixins/adminBrands";
import CustomFieldsMixin from "@/mixins/customFieldsMixin";
import TagsMixin from "@/mixins/tagsMixin";
import ContractProductsFiltersMixins from "@/mixins/provisioning/contractProductsFiltersMixins";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import {
  CProdFilters,
  CProdClientsFilters
} from "@/data/filters/contractProducts";
import { DefaultCProdSorters } from "@/data/sorters/contractProducts";

import { ISegmentTypes } from "@/data/enums/segments";
import { IContractProduct } from "@/models/contracts";
import { ContractStatusCodes } from "@/models/contracts";

// Types
import { IFilter, ISorter } from "@/models/tables";
import { CustomFieldsMajorTypes } from "@/data/enums/customFields";
import { IClient } from "@/models/clients";
import { PriceType } from "@/data/enums/contractProducts";
import { IAccount } from "@/models/accounts";

@Component({
  components: {
    "add-segment-message": () =>
      import("@/components/app/admin/segments/addSegmentMessage.vue"),
    "cprod-status-summary": () =>
      import("@/components/app/global/contractProducts/cProdStatusSummary.vue"),
    "product-image": () =>
      import("@/components/app/global/products/productImage.vue")
  },
  computed: {
    ...mapGetters({
      isMultibrand: "brand/isMultibrand"
    })
  }
})
export default class ContractsProductsTable extends Mixins(
  FilteringSortingTableStore,
  TagsMixin,
  CustomFieldsMixin,
  SegmentTableMixin,
  BillingCyclesStore,
  AdminBrands,
  ContractProductsFiltersMixins,
  MultilevelCategoriesFetcher
) {
  // State/Getters
  public isMultibrand!: boolean;

  // New

  @Prop({ default: "u-contract-product-link" })
  public rowTag!: string;

  @Prop({ default: () => () => ({}) })
  public rowEvents!: (
    contractProduct: IContractProduct
  ) => { [key: string]: Function };

  // Props

  @Prop({ default: "CPT" })
  public declare id: string;

  @Prop({ default: null })
  public clientId!: IClient["id"];

  @Prop({ default: null })
  public accountId!: IAccount["id"];

  @Prop({ default: false })
  public isSegment!: boolean;

  @Prop({ default: false })
  public isSegmentLoading!: boolean;

  @Prop({ default: "" })
  public segmentType!: ISegmentTypes;

  @Prop({ default: false })
  public segmentedView!: boolean;

  @Prop({ default: () => [] })
  public statuses!: ContractStatusCodes[];

  @Prop({ default: false })
  public isStaged!: boolean;

  @Prop({ default: true })
  public showWhenPurchased!: boolean;

  @Prop({ default: () => ({}) })
  public readonly manualFilters!: { [key: string]: string | number | boolean };

  // Variables
  public dataModule: DataModules = DataModules.CONTRACTS_PRODUCTS;
  public isLoading = false;
  public isReloading = false;
  public requestError = false;

  public filters: IFilter[] = [];
  public sorters: ISorter[] = [];

  public async created() {
    if (!this.contentIsAvailable) {
      return;
    }

    this.isLoading = true;
    this.loading = true;
    this.loadData();
  }

  public async loadData() {
    try {
      if (this.isAdmin) {
        // Provisioning
        await this.getOrgProvisioning(this.isReloading);

        await Promise.all([
          this.hasProvisioning
            ? this.getFiltersData(this.isReloading, this.isStaged)
            : Promise.resolve(),
          this.getClientCustomFields(this.isReloading, this.isStaged),
          this.getTags(this.isReloading, this.isStaged),
          this.getRootCategories(this.isReloading, this.isStaged)
        ]);
      }

      if (this.isSegment) {
        this.dataModule = DataModules.SEGMENTS_RESULTS;
        this.dataPayloadSettings = { id: this.segmentId };
      }

      this.apiProps = this.$_.merge(
        {
          with: this.$_.compact([
            !this.clientId && !this.accountId && "clients,clients.image",
            this.isAdmin && "provision_provider.logos",
            "status,product,product.image,product.brand.currency"
          ]).join(",")
        },
        this.isStaged ? { with_staged_imports: 1 } : {},
        this.manualFilters,
        this.accountId
          ? { "filter[account_id]": this.accountId }
          : this.clientId
          ? { "filter[clients.id]": this.clientId }
          : {}
      );

      this.setFiltersAndSorters();
      this.getData();
    } catch (error) {
      this.requestError = true;
      this.$store.dispatch("api/handleError", error);
    }

    this.isLoading = false;
    this.isReloading = false;
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public setFiltersAndSorters() {
    this.filters = this.$_.concat(
      this.getProductCategoryFilledFilters(
        CProdFilters({ statuses: this.statuses }),
        true,
        this.isOneTimePurchase
      ),
      this.isAdmin ? this.createProvisionFilters(this.isOneTimePurchase) : [],
      this.isAdmin && !this.clientId && !this.accountId
        ? this.$_.concat(
            CProdClientsFilters(),
            [
              this.createTagFilter(
                "clients.tags.id",
                this.$t("_.client_tag"),
                "client"
              )
            ],
            this.customFieldsFilters(
              CustomFieldsMajorTypes.CLIENT,
              "client",
              "client_custom_fields"
            )
          )
        : []
    );

    this.sorters = this.$_.filter(DefaultCProdSorters(), sorter => {
      return this.isOneTimePurchase ? sorter.field === "created_at" : true;
    });
  }

  public isConvertedPrice(type: PriceType) {
    return type === PriceType.CONVERTED;
  }

  public isManualPrice(type: PriceType) {
    return type === PriceType.MANUAL;
  }

  public get recurringFilterParam() {
    if (this.isSegment) {
      return {};
    }

    if (this.isOneTimePurchase) {
      return { "filter[billing_cycle_months]": 0 };
    }

    if (this.isSubscription) {
      return { "filter[billing_cycle_months|gt]": 0 };
    }

    return {};
  }

  public get statusesFilter() {
    return this.statuses.length
      ? { "filter[status.code]": this.statuses.join() }
      : {};
  }

  public getStoreParams(params: any): Promise<any> {
    return this.$_.merge(
      {
        params: this.$_.merge(
          params.filter,
          this.statusesFilter,
          this.recurringFilterParam
        )
      },
      params
    );
  }

  public getTaxAwareTotal(cProd: IContractProduct) {
    // Recurring total
    if (this.isSubscription)
      return this.$store.getters["brand/taxAwarePrice"]({
        taxType: cProd.product?.brand?.tax_type,
        taxIncPrice: cProd.configuration_total_recurring_amount_formatted,
        taxExcPrice: cProd.configuration_total_recurring_net_amount_formatted
      });
    // One-time total
    return this.$store.getters["brand/taxAwarePrice"]({
      taxType: cProd.product?.brand?.tax_type,
      taxIncPrice: cProd.configuration_total_discounted_amount_formatted,
      taxExcPrice: cProd.configuration_net_amount_discounted_formatted
    });
  }

  public get isSubscription() {
    return this.segmentType === ISegmentTypes.CONTRACTS_PRODUCTS_SUBSCRIPTION;
  }

  public get isOneTimePurchase() {
    return this.segmentType === ISegmentTypes.CONTRACTS_PRODUCTS_SALE;
  }

  public get guardFunctionalities() {
    return this.isClient
      ? []
      : this.$_.concat(
          ["list_client_fields"],
          this.isSegment
            ? ["list_segment_results"]
            : ["list_contracts_products"]
        );
  }

  public get contentIsAvailable() {
    return this.isClient || this.$userCan(...this.guardFunctionalities);
  }

  @Watch("segment.params.filter", { deep: true })
  public onSegmentFiltersChange(newValue, oldValue) {
    if (this.$_.isEqual(newValue, oldValue) || this.isLoading) {
      return;
    }

    this.getData({ ignoreStored: true });
  }
}
